import { render } from "./ThemeSwitcher.vue?vue&type=template&id=0dd8f10c&scoped=true"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=js"

import "./ThemeSwitcher.vue?vue&type=style&index=0&id=0dd8f10c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd8f10c"]])

export default __exports__